/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpeciesReading } from './SpeciesReading';
import {
    SpeciesReadingFromJSON,
    SpeciesReadingFromJSONTyped,
    SpeciesReadingToJSON,
    SpeciesReadingToJSONTyped,
} from './SpeciesReading';
import type { FieldReading } from './FieldReading';
import {
    FieldReadingFromJSON,
    FieldReadingFromJSONTyped,
    FieldReadingToJSON,
    FieldReadingToJSONTyped,
} from './FieldReading';
import type { Verdict } from './Verdict';
import {
    VerdictFromJSON,
    VerdictFromJSONTyped,
    VerdictToJSON,
    VerdictToJSONTyped,
} from './Verdict';

/**
 * 
 * @export
 * @interface CurrentReading
 */
export interface CurrentReading {
    /**
     * 
     */
    length: FieldReading;
    /**
     * 
     */
    girth: FieldReading;
    /**
     * 
     */
    weight: FieldReading;
    /**
     * 
     */
    species: SpeciesReading;
    /**
     * 
     */
    notFish: boolean;
    /**
     * 
     */
    verdict: Verdict | null;
    /**
     * 
     */
    state: CurrentReadingStateEnum;
    /**
     * 
     */
    changed: Array<CurrentReadingChangedEnum>;
}


/**
 * @export
 */
export const CurrentReadingStateEnum = {
    Unchecked: 'unchecked',
    Confirmed: 'confirmed',
    Corrected: 'corrected',
    Disputed: 'disputed',
    NotFish: 'not_fish',
} as const;
export type CurrentReadingStateEnum = typeof CurrentReadingStateEnum[keyof typeof CurrentReadingStateEnum];

/**
 * @export
 */
export const CurrentReadingChangedEnum = {
    Length: 'length',
    Girth: 'girth',
    Weight: 'weight',
    Species: 'species',
} as const;
export type CurrentReadingChangedEnum = typeof CurrentReadingChangedEnum[keyof typeof CurrentReadingChangedEnum];


/**
 * Check if a given object implements the CurrentReading interface.
 */
export function instanceOfCurrentReading(value: object): value is CurrentReading {
    if (!('length' in value) || value['length'] === undefined) return false;
    if (!('girth' in value) || value['girth'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('species' in value) || value['species'] === undefined) return false;
    if ((!('notFish' in (value as Record<string, any>)) && !('not_fish' in (value as Record<string, any>))) || ((value as Record<string, any>)['notFish'] === undefined && (value as Record<string, any>)['not_fish'] === undefined)) return false;
    if (!('verdict' in value) || value['verdict'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('changed' in value) || value['changed'] === undefined) return false;
    return true;
}

export function CurrentReadingFromJSON(json: any): CurrentReading {
    return CurrentReadingFromJSONTyped(json, false);
}

export function CurrentReadingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentReading {
    if (json == null) {
        return json;
    }
    return {
        
        'length': FieldReadingFromJSON(json['length']),
        'girth': FieldReadingFromJSON(json['girth']),
        'weight': FieldReadingFromJSON(json['weight']),
        'species': SpeciesReadingFromJSON(json['species']),
        'notFish': json['not_fish'],
        'verdict': VerdictFromJSON(json['verdict']),
        'state': json['state'],
        'changed': json['changed'],
    };
}

export function CurrentReadingToJSON(json: any): CurrentReading {
    return CurrentReadingToJSONTyped(json, false);
}

export function CurrentReadingToJSONTyped(value?: CurrentReading | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'length': FieldReadingToJSON(value['length']),
        'girth': FieldReadingToJSON(value['girth']),
        'weight': FieldReadingToJSON(value['weight']),
        'species': SpeciesReadingToJSON(value['species']),
        'not_fish': value['notFish'],
        'verdict': VerdictToJSON(value['verdict']),
        'state': value['state'],
        'changed': value['changed'],
    };
}

